import difference from 'lodash/difference';
import {
  GETTER_ACTIVE_PRINT_SIDE,
  GETTER_ACTIVE_PRINT_SIDE_PRINT_PLATE
} from '../store/getters';
import {
  GETTER_ELEMENT_CAPABILITIES,
  GETTER_PRINT_PLATE_CAPABILITIES
} from '../store/capabilities';
import { GETTER_PRODUCT_IS_LOADED } from '@/store/modules/product/getters';

export default {
  methods: {
    getPrintPlateCapabilites: function (printPlate, side) {
      return this.$store.getters[GETTER_PRINT_PLATE_CAPABILITIES](
        printPlate,
        side
      );
    },
    getElementCapabilities: function (element) {
      return this.$store.getters[GETTER_ELEMENT_CAPABILITIES](element);
    },
    elementSupports: function (element, ...capabilities) {
      return (
        difference(capabilities, this.getElementCapabilities(element))
          .length === 0
      );
    },
    printPlateSupports: function (printPlate, side, ...capabilities) {
      return (
        difference(
          capabilities,
          this.getPrintPlateCapabilites(printPlate, side)
        ).length === 0
      );
    },
    activePrintPlateSupports: function (...capabilities) {
      if (!this.$store.getters[GETTER_PRODUCT_IS_LOADED]) {
        return false;
      }

      return this.printPlateSupports(
        this.$store.getters[GETTER_ACTIVE_PRINT_SIDE_PRINT_PLATE],
        this.$store.getters[GETTER_ACTIVE_PRINT_SIDE],
        ...capabilities
      );
    }
  }
};
